module.exports = import("https://esm.sh/rehype-highlight@7.0.1");;